module.exports = __webpack_public_path__ + "img/e_3_14_r.d5be5155.png";